export default __webpack_public_path__ + "static/team-6cd6555c6c900b34324030543167c6b0.svg";